import { types, async } from "../utils/type-creator";

export default types(
  [...async("GET_ACCESS_TOKEN"),...async("DELETE"), ...async("LIST"), ...async("REGISTER")],
  "POWERBI"
);
